{
  "zh-TW": {
    "headlines": {
      "vehicleOverview": {
        "paints": "%{model} 塗裝",
        "location": "艦船在哪裡？",
        "picture": "艦船圖片"
      },
      "vehicleLog": {
        "create": "新日誌條目",
        "edit": "編輯日誌條目",
        "public": "艦長日誌：%{vehicle}"
      },
      "hangarShare": "分享連結",
      "locations": {
        "index": "地點",
        "places": "所有地點"
      },
      "admin": {
        "locations": {
          "index": "地點"
        },
        "blueprints": {
          "index": "藍圖",
          "materials": "材料",
          "stats": "屬性",
          "sources": "來源"
        },
        "missions": {
          "index": "任務"
        },
        "dashboard": {
          "title": "儀表板",
          "visitsPerDay": "每日訪問",
          "visitsPerMonth": "每月訪問",
          "mostViewedPages": "瀏覽最多的頁面",
          "registrationsPerMonth": "每月註冊數"
        },
        "models": {
          "index": "型號",
          "edit": {
            "index": "編輯型號",
            "fleetchart": "艦隊圖表圖片",
            "positions": "乘員位置",
            "hardpoints": "掛載點",
            "cargoAndFuel": "燃料",
            "cargoHolds": "貨艙",
            "metrics": "指標",
            "prices": "價格",
            "docks": "停靠口",
            "modules": "模組",
            "paints": "塗裝",
            "videos": "影片",
            "images": "圖片",
            "itemPrices": "物品價格",
            "linkModule": "連結現有模組",
            "loaners": "借用船",
            "snubCrafts": "艦載小艇",
            "upgrades": "升級",
            "packages": "套餐",
            "linkUpgrade": "連結現有升級",
            "history": "歷史記錄"
          },
          "new": "新型號",
          "show": "型號",
          "images": "圖片",
          "tableConfigurationModal": "表格設定"
        },
        "components": {
          "index": "組件",
          "new": "新組件",
          "edit": {
            "index": "編輯組件",
            "itemPrices": "物品價格",
            "history": "歷史記錄"
          }
        },
        "modelPaints": {
          "index": "塗裝",
          "new": "新塗裝",
          "edit": "編輯塗裝",
          "copy": "複製塗裝至飛船",
          "bulkCopy": "複製 %{count} 個塗裝至飛船"
        },
        "modelModules": {
          "index": "模組",
          "new": "新模組",
          "edit": "編輯模組",
          "models": "關聯型號",
          "prices": "價格",
          "hardpoints": "掛載點",
          "docks": "停靠點",
          "cargoHolds": "貨艙",
          "history": "歷史記錄"
        },
        "unlistedModels": {
          "index": "遊戲檔案中沒有對應條目的飛船",
          "link": "關聯到目錄中的飛船"
        },
        "manufacturers": {
          "index": "製造商",
          "new": "新製造商",
          "edit": {
            "index": "編輯製造商"
          }
        },
        "announcements": {
          "index": "公告",
          "new": "新增公告",
          "edit": "編輯公告",
          "deliveries": "投遞狀況"
        },
        "supporterContributions": {
          "index": "支持者貢獻",
          "new": "新增支持者貢獻",
          "edit": "編輯支持者貢獻",
          "perMonth": "每月貢獻"
        },
        "fundingGoals": {
          "index": "資金目標",
          "new": "新增資金目標",
          "edit": "編輯資金目標"
        },
        "users": {
          "index": "使用者",
          "edit": "編輯使用者",
          "fleets": "艦隊",
          "inventories": "庫存",
          "supporterContributions": "支持者貢獻"
        },
        "vehicles": {
          "index": "載具",
          "edit": "編輯載具"
        },
        "fleets": {
          "index": "艦隊",
          "edit": "編輯艦隊",
          "members": "成員",
          "memberEdit": "編輯成員",
          "history": "歷史記錄",
          "roles": "角色",
          "inventories": "庫存",
          "inventoryItems": "庫存記錄"
        },
        "fleetFidClaims": {
          "index": "艦隊 ID 申領"
        },
        "destroyedFleets": {
          "index": "已刪除艦隊"
        },
        "admins": {
          "index": "管理員",
          "new": "新管理員",
          "edit": "編輯管理員"
        },
        "oauthApplications": {
          "index": "OAuth 應用程式",
          "new": "新增 OAuth 應用程式",
          "edit": "編輯 OAuth 應用程式",
          "reject": "拒絕 %{name}",
          "rejectBulk": "拒絕 %{count} 個應用程式"
        },
        "features": {
          "index": "功能標誌",
          "show": "功能詳情",
          "globalState": "全域狀態",
          "groups": "群組",
          "actors": "角色",
          "selfService": "自助服務",
          "percentageOfActors": "角色百分比",
          "percentageOfTime": "時間百分比",
          "addActor": "新增角色",
          "history": "變更歷史",
          "addUser": "為使用者啟用",
          "addFleet": "為艦隊啟用",
          "enabledUsers": "已啟用的使用者",
          "enabledFleets": "已啟用的艦隊"
        },
        "rsiApiStatus": {
          "index": "RSI API 狀態"
        },
        "images": {
          "index": "圖片"
        },
        "imports": {
          "index": "匯入"
        },
        "notifications": {
          "index": "通知"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "視覺測試",
          "notifications": "通知"
        },
        "buildCompare": {
          "index": "版本比較"
        }
      },
      "welcome": "Welcome to",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "飛船艦隊圖表"
      },
      "images": "Images Index",
      "stats": "統計",
      "notFound": "導航錯誤",
      "forbidden": "拒絕存取",
      "subscriptionRequired": "支持者功能",
      "featureNotReady": "即將推出",
      "inviteInvalid": "邀請連結無效",
      "accessDenied": "拒絕存取",
      "serverError": "伺服器錯誤",
      "offline": "連線已中斷",
      "invalidRequest": "無效的請求",
      "comments": "評論",
      "login": "登入",
      "hangar": {
        "index": "我的機庫",
        "preview": {
          "title": "你的機庫",
          "lead": "記錄你擁有的每一艘艦船——註冊 FleetYards.net 帳號即可免費使用。"
        },
        "alternativeNames": "別名",
        "stats": "統計",
        "public": "%{user} 的機庫",
        "import": "匯入",
        "wishlist": "願望清單",
        "publicStats": "統計",
        "publicWishlist": "%{user} 的願望清單",
        "resetIngame": "資料重置後重設遊戲內飛船",
        "buybacks": "可回購承諾",
        "paints": "塗裝",
        "flair": "機庫裝飾",
        "equipment": "FPS 裝備",
        "imports": "匯入記錄"
      },
      "buybackSync": "同步 RSI 可回購承諾",
      "syncExtension": "同步 RSI 機庫",
      "editMyVehicle": "Edit my %{vehicle}",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "myVehicleLoadouts": "%{vehicle} 的裝配",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "法律聲明",
      "privacy": "隱私政策",
      "cookie": "Cookie policy",
      "requestPassword": "請求密碼",
      "changePassword": "變更密碼",
      "confirmAccess": "Confirm access",
      "setEmail": "設定電子郵件地址",
      "oauthAuthorize": "授權應用程式",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "directory": "艦隊目錄",
        "owners": "Owners",
        "add": "Create a new Fleet",
        "invites": "艦隊邀請",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "成員世界地圖",
          "starmap": "成員星圖",
          "health": "成員健康檢查"
        },
        "squadrons": {
          "index": "中隊",
          "create": "建立中隊",
          "edit": "編輯中隊",
          "formDetails": "詳細資訊",
          "formAppearance": "外觀",
          "formDiscord": "Discord",
          "ranks": "中隊職級",
          "editMember": "編輯中隊成員",
          "editRank": "編輯中隊職級",
          "teams": "小隊",
          "addMembers": "新增成員",
          "members": "成員"
        },
        "stats": "統計",
        "preview": {
          "title": "你的艦隊",
          "lead": "把你的組織聚在一起——註冊 FleetYards.net 帳號即可免費使用。"
        },
        "settings": {
          "fleet": "Fleet Settings",
          "rsi": "艦隊 ID 與 RSI",
          "membership": "Membership Settings",
          "roles": "艦隊角色",
          "squadrons": "艦隊中隊",
          "allies": "艦隊盟友",
          "notifications": "通知設定",
          "inAppNotifications": "應用內通知",
          "discord": "Discord",
          "calendar": "行事曆",
          "contracts": "合約設定",
          "features": "艦隊功能"
        },
        "inviteMember": "Invite new Member",
        "calendarSubscription": "行事曆訂閱",
        "missions": {
          "index": "任務",
          "create": "建立任務",
          "edit": "編輯任務",
          "editDetails": "詳細資訊",
          "editDescription": "描述與封面",
          "editTeams": "小隊與席位",
          "teams": "小隊",
          "ships": "飛船",
          "slots": "席位",
          "addTeam": "新增小隊",
          "editTeam": "編輯小隊",
          "addShip": "新增飛船",
          "editShip": "編輯飛船"
        },
        "events": {
          "expandShip": "增加席位",
          "index": "活動",
          "calendar": "行事曆",
          "create": "建立活動",
          "edit": "編輯活動",
          "editDetails": "詳細資訊",
          "editSchedule": "時間安排",
          "editSignup": "報名",
          "editDescription": "描述與封面",
          "editTeams": "小隊與席位",
          "spawn": "產生活動",
          "details": "活動詳情",
          "schedule": "排程",
          "settings": "設定",
          "lifecycle": "生命週期",
          "signupTitle": "我要報名",
          "yourSignup": "你的報名",
          "spawnedFrom": "由此任務產生",
          "pickTemplate": "選擇任務範本",
          "unassignedSignups": "未分配的報名",
          "eventTeam": "活動小隊",
          "grantRole": "授予角色",
          "editTeam": "編輯小隊",
          "addTeam": "新增小隊",
          "editShip": "編輯飛船",
          "addShip": "新增飛船",
          "assignSlotFor": "為 %{username} 分配席位",
          "reassignSlotFor": "為 %{username} 重新分配席位"
        },
        "memberNickname": "成員暱稱",
        "editRole": "編輯角色",
        "contracts": {
          "index": "合約",
          "create": "建立合約",
          "edit": "編輯合約",
          "progress": "進度",
          "crew": "隊伍",
          "items": "貨物",
          "editItem": "編輯貨物",
          "addItem": "新增貨物",
          "views": {
            "open": "合約",
            "closed": "已結束的合約",
            "mine": "我的合約",
            "completed": "已完成的合約"
          }
        }
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "比較飛船"
      },
      "settings": {
        "account": "帳戶",
        "profile": "個人資料設定",
        "hangar": "機庫設定",
        "privacy": "隱私設定",
        "features": "功能標誌",
        "connections": "連線",
        "oauthApplications": "OAuth 應用程式",
        "notifications": "通知設定",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "帳戶安全",
          "twoFactor": "Two-factor Authentication"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentication",
          "disable": "Disable Two-factor Authentication",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "calendar": "行事曆訂閱",
        "donations": "捐贈"
      },
      "oauthApplications": {
        "new": "新增 OAuth 應用程式",
        "edit": "編輯 OAuth 應用程式"
      },
      "roadmap": "飛船路線圖",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行時間",
        "cargoGrids": "貨物網格",
        "tradeRoutes": "貿易路線"
      },
      "rsiVerification": "Verify your RSI-Account",
      "support": "Support FleetYards.net",
      "supporters": "感謝我們的支持者",
      "installApp": {
        "offer": "隨身攜帶 FleetYards",
        "ios": "安裝 FleetYards"
      },
      "supportHint": {
        "hangarSync": "很高興能幫你完成同步",
        "vehicleAdded": "你的機庫在不斷成長",
        "fleetCreated": "新艦隊 — 恭喜!",
        "loginMilestone": "感謝你一直以來的支持",
        "visitMilestone": "喜歡 FleetYards 嗎?"
      },
      "vehicle": {
        "bulkGroupEdit": "新增/移除群組"
      },
      "pagination": {
        "count": "%{current} / %{total}"
      },
      "models": {
        "index": "型號"
      },
      "modals": {
        "models": {
          "displayOptions": "顯示選項"
        }
      },
      "visualTests": {
        "overview": "概覽",
        "panels": "面板",
        "buttons": "按鈕",
        "media": "媒體",
        "charts": "圖表",
        "blueprints": "藍圖",
        "squadrons": "中隊",
        "alerts": "提示",
        "verifiedBadges": "驗證徽章",
        "chips": "視覺測試 Chips",
        "events": "活動",
        "typography": "排版",
        "forms": "表單",
        "tables": "表格",
        "lists": "列表",
        "metrics": "指標",
        "states": "狀態",
        "notifications": "通知",
        "syncModal": "同步彈窗",
        "buybackSyncModal": "回購同步彈窗",
        "rsiVerificationModal": "RSI 驗證彈窗",
        "fleetRsiVerificationModal": "艦隊 RSI 驗證彈窗",
        "overlays": "覆蓋層",
        "installPrompt": "安裝提示",
        "supportHint": "支援提示",
        "notificationCenter": "通知中心",
        "themes": "主題"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item",
        "transfer": "轉移庫存",
        "transfers": "轉移",
        "acceptTransfer": "接受轉移",
        "reportTransfer": "檢舉轉移"
      },
      "notifications": {
        "index": "通知"
      },
      "payouts": {
        "index": "分帳",
        "summary": "概要",
        "participants": "參與者",
        "entries": "紀錄",
        "balances": "餘額",
        "transfers": "分帳清單",
        "addEntry": "記一筆",
        "editEntry": "編輯紀錄",
        "addParticipant": "新增參與者",
        "tours": {
          "index": "行程",
          "create": "建立行程",
          "join": "加入此行程"
        },
        "declineExpense": "拒絕支出"
      },
      "relationships": {
        "user": {
          "index": "好友",
          "add": "新增好友"
        },
        "fleet": {
          "add": "新增盟友"
        }
      },
      "fleet": {
        "contractCovers": "合約封面圖"
      },
      "component": {
        "temperature": "溫度",
        "misfire": "故障",
        "history": "歷史",
        "craftedFrom": "製造配方",
        "identity": "詳情",
        "metrics": "數據",
        "requiredTags": "可裝入具備以下標籤的接口",
        "tags": "標籤",
        "physical": "物理屬性",
        "damageTaken": "承受傷害",
        "durability": "耐久性",
        "selfRepair": "自我修復",
        "distortion": "扭曲",
        "splineJump": "軌道躍遷"
      },
      "commodity": {
        "priceHistory": "價格歷史",
        "identity": "詳情",
        "usedIn": "用於"
      },
      "commodities": {
        "index": "商品"
      },
      "components": {
        "index": "部件"
      },
      "blueprints": {
        "index": "藍圖"
      },
      "missions": {
        "index": "任務"
      },
      "missions": {
        "index": "任務"
      },
      "equipment": {
        "index": "裝備",
        "metrics": "數據",
        "identity": "詳情",
        "craftedFrom": "製造配方"
      }
    }
  }
}
